import { SECTIONS_BY_SCHEME } from '../../constants/validateDeclaration.constants';
import { BasicInformationSection } from './BasicInformationSection';
import { AllocationRulesSection } from './AllocationRulesSection';
import { SustainabilityDeclarationDetailsSection } from './SustainabilityDeclarationDetailsSection';
import { ProductInformationSection } from './ProductInformationSection';
import { ValidateDeclarationQuantityFields } from './ValidateDeclarationQuantityFields';
import { ComplianceContextSection } from './ComplianceContextSection';
import { CertificationScopeSection } from './CertificationScopeSection';
import { GhgEmissionDetailsSection } from './GhgEmissionDetailsSection';
import { GhgEmissionSavingSection } from './GhgEmissionSavingSection';
import { VoluntaryAddOnsSection } from './VoluntaryAddOnsSection';
import styles from './ValidateDeclarationForm.module.scss';

/**
 * Props:
 *   certificateType  MODULE_CERTIFICATE_TYPES[module]
 *   formOptions      useValidateDeclarationFormOptions() result
 *   setValue         (name, value) => void, from the enclosing <Form>
 *   locked           a linked shipment set Received at/Material/Supplier — disables those fields
 */
export const ValidateDeclarationForm = ({ certificateType, formOptions, setValue, locked }) => {
  if (!SECTIONS_BY_SCHEME[certificateType]) return null;

  return (
    <div className={styles.scrollArea}>
      <BasicInformationSection formOptions={formOptions} setValue={setValue} locked={locked} />
      <AllocationRulesSection formOptions={formOptions} />
      <SustainabilityDeclarationDetailsSection setValue={setValue} />
      <ProductInformationSection formOptions={formOptions} />
      <ValidateDeclarationQuantityFields materials={formOptions.materials} />
      <ComplianceContextSection formOptions={formOptions} />
      <CertificationScopeSection formOptions={formOptions} />
      <GhgEmissionDetailsSection formOptions={formOptions} />
      <GhgEmissionSavingSection />
      <VoluntaryAddOnsSection formOptions={formOptions} />
    </div>
  );
};
